import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
function Form104SignDialog({ formOpen, onConfirm }) {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <Dialog aria-labelledby="simple-dialog-title" open={formOpen}>
                <DialogTitle id="simple-dialog-title">
                    {t("Form104.dialog.title")}
                </DialogTitle>
                <DialogContent>{t("Form104.dialog.content")}</DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={onConfirm} color="success">
                        <b>{t("common.portal.close")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default Form104SignDialog;
